import { RouteRecordRaw } from "vue-router";
import { UserRoleEnum } from "@/app/core/enums/UserRoleEnum";

export const routePrivateAdmin: Array<RouteRecordRaw> = [
  {
    path: "admin",
    name: "Admin",
    meta: {
      requireAuth: true,
      roles: [UserRoleEnum.Admin],
    },
    props: true,
    component: () => import("@/app/private/pages/admin/Admin.vue"),
  },
  {
    path: "admin/accounts/:id",
    name: "AccountView",
    meta: {
      requireAuth: true,
      roles: [UserRoleEnum.Admin],
    },
    props: true,
    component: () => import("@/app/private/pages/admin/AccountView.vue"),
  },
  {
    path: "admin/accounts/new",
    name: "AccountCreate",
    meta: {
      requireAuth: true,
      roles: [UserRoleEnum.Admin],
    },
    props: true,
    component: () => import("@/app/private/pages/admin/AccountCreate.vue"),
  }
    
];
